import fb from '@/services/firebase.js'
import router from '../../router'

export const namespaced = true

export const state = {
  loading: false
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  }
}

export const actions = {
  isLoggedIn({ commit }) {
    commit('SET_LOADING', true)
    fb.auth.onAuthStateChanged(user => {
      if (!user) {
        if (router.currentRoute.name != 'Register') {
          router.push({
            name: 'Register'
          })
        }
      } else {
        fb.db
          .collection('users')
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              if (router.currentRoute.name == 'Register' || router.currentRoute.name == 'Complete') {
                router.push({
                  name: 'Dashboard'
                })
              }
            } else {
              if (router.currentRoute.name != 'Complete') {
                router.push({
                  name: 'Complete'
                })
              }
            }
          })
      }
    })
  },
  hasFilledDetails({ commit }) {
    commit('SET_LOADING', true)
    fb.auth.onAuthStateChanged(user => {
      if (user) {
        fb.db
          .collection('users')
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              router.push({
                name: 'Dashboard'
              })
            }
          })
      }
    })
  }
}

export const getters = {}
